import { useAppActions } from 'reducers/slices/bidSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { loadBidRequest, changeBidFormInputValue, createBid, setBidFormInputValues } = useAppActions();
  const { loading, bidRequest, bid, bidsFormInputValues } = useSelector(state => state.bidSlice);

  return {
    loadBidRequest,
    changeBidFormInputValue,
    createBid,
    setBidFormInputValues,
    bidsFormInputValues,
    bidRequest,
    loading,
    bid,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useBid.js